import { useMutation } from '@tanstack/react-query';

import { infoTechApi } from 'api/infoTech';

export function useSendNetSuitePromptMutation({ onError, onSuccess } = {}) {
    return useMutation({
        mutationFn: async (prompt) => {
            const res = await infoTechApi.sendNetSuitePrompt(prompt);
            if (!res.status) {
                throw new Error(res.msg || 'Failed to send prompt');
            }
            // eslint-disable-next-line no-console -- debug: inspect NetSuite LLM API payload
            console.log('NetSuite AI sendprompt response', res.data);
            return res.data;
        },
        onError,
        onSuccess,
    });
}
